import loadable from "@loadable/component";
import useIsDesktop from "hooks/useIsDesktop";
import FullPageLoader from "@Components/FullPageLoader";

const SettingsMobile = loadable(() => import("./Settings"), {
  fallback: <FullPageLoader />,
});

const SettingsDesktop = loadable(() => import("./Desktop/SettingsDesktop"), {
  fallback: <FullPageLoader />,
});

const Settings = () => {
  const isDesktop = useIsDesktop();

  return isDesktop ? <SettingsDesktop /> : <SettingsMobile />;
};

export default Settings;
